export type SnListItemClickHandler = () => void;
